import companies from './../../../public/map-markers/companies.svg';
import companiesHover from './../../../public/map-markers/companies-hover.svg';

import education from './../../../public/map-markers/education.svg';
import educationHover from './../../../public/map-markers/education-hover.svg';

import health from './../../../public/map-markers/health.svg';
import healthHover from './../../../public/map-markers/health-hover.svg';

import leisure from './../../../public/map-markers/leisure.svg';
import leisureHover from './../../../public/map-markers/leisure-hover.svg';

import parks from './../../../public/map-markers/parks.svg';
import parksHover from './../../../public/map-markers/parks-hover.svg';

import restaurantsBars from './../../../public/map-markers/restaurants-bars.svg';
import restaurantsBarsHover from './../../../public/map-markers/restaurants-bars-hover.svg';

import shops from './../../../public/map-markers/shops.svg';
import shopsHover from './../../../public/map-markers/shops-hover.svg';

import transportation from './../../../public/map-markers/transportation.svg';
import transportationHover from './../../../public/map-markers/transportation-hover.svg';

const icons = {
    companies: {
        icon: companies,
        hover: companiesHover
    },
    education: {
        icon: education,
        hover: educationHover
    },
    health: {
        icon: health,
        hover: healthHover
    },
    leisure: {
        icon: leisure,
        hover: leisureHover
    },
    parks: {
        icon: parks,
        hover: parksHover
    },
    'restaurants-bars': {
        icon: restaurantsBars,
        hover: restaurantsBarsHover
    },
    shops: {
        icon: shops,
        hover: shopsHover
    },
    transportation: {
        icon: transportation,
        hover: transportationHover
    }

}

let contactMap

// export default function nearByMap() {
export default async function initMap() {
    const { Map } = await google.maps.importLibrary("maps");

    //map options
    const mapOptions = {
        zoom: 14,
        disableDefaultUI: true,
        scrollwheel: false,
        center: {
            lat: Number(ajaxObject.mapOptions.main_marker_latitude), 
            lng: Number(ajaxObject.mapOptions.main_marker_longitude)
        },
        styles: [
            {
                "featureType": "landscape",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#e6e4e0"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "geometry",
                "stylers": [
                    {
                        "saturation": "1"
                    },
                    {
                        "color": "#cee4bf"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "poi.medical",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#ead2da"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "all",
                "stylers": [
                    {
                        "saturation": "-100"
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "all",
                "stylers": [
                    {
                        "saturation": "-100"
                    },
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#75cff0"
                    }
                ]
            }
        ]
    }
    //new map
    // const contactMap = new google.maps.Map(document.querySelector('#map-near-by'), mapOptions);
    contactMap = new Map(document.getElementById("map-near-by"), mapOptions);
    //image
    const image = {
            url: ajaxObject.mapOptions.main_marker_icon.url,
            size: new google.maps.Size(64, 64),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(0, 40)
    };
    // main marker
    const contactMarker = new google.maps.Marker({
        position:{
            lat: Number(ajaxObject.mapOptions.main_marker_latitude), 
            lng: Number(ajaxObject.mapOptions.main_marker_longitude)
        },
        map: contactMap,
        icon: image
    });

    // categories from list
    const markersCategories = document.querySelectorAll('.js-marker-category');
    // console.log(markersCategories)

    let activeInfoWindow;

    let markerGroups = [];

    for(const marker of ajaxObject.mapMarkers) {
        markerGroups.push(marker.icon);
    }

    // console.log(markerGroups)

    if(ajaxObject.mapMarkers){
        // console.table(ajaxObject.mapMarkers)

        for (const markers of ajaxObject.mapMarkers) {
            if (markers.markers) {

                for(const marker of markers.markers) {
                    createMarker({
                        // icon: `/app/themes/vsbl/public/images/map-markers/${markers.icon}.svg`,
                        // icon_hover: `/app/themes/vsbl/public/images/map-markers/${markers.icon}-hover.svg`,
                        icon: icons[markers.icon].icon,
                        // icon: icons['parks'].icon,
                        icon_hover: icons[markers.icon].hover,
                        map: contactMap,
                        lat: Number(marker.marker_latitude),
                        lng: Number(marker.marker_longitude),
                        type: `${markers.icon}`,
                        html: `<span class="block">${marker.title}</span><span class="text-gray-4">${marker.address}</span><div class="flex flex-row justify-between items-center pr-6 pt-4 text-base"><span class="car">${marker.ride_time}</span><span class="men">${marker.walk_time}</span></div>`
                    });

                }
            }
        }
    }

    // Events
    const zoomin = document.querySelector('#zoomin');
    const zoomout = document.querySelector('#zoomout');

    zoomout.addEventListener( 'click', () => {
        const currentZoomLevel = contactMap.getZoom();
        if(currentZoomLevel != 0){
            contactMap.setZoom(currentZoomLevel - 1);
        }
    });

    zoomin.addEventListener('click', function() {
        const currentZoomLevel = contactMap.getZoom();
        if(currentZoomLevel != 21){
            contactMap.setZoom(currentZoomLevel + 1);
        }
    });

    // functions
    function createMarker(args){
        // console.log('type ', args.type)
        const icon = args.icon;
        const icon_hover = args.icon_hover;
        const marker = new google.maps.Marker({
            position:{ lat: args.lat, lng: args.lng},
            map: args.map,
            icon: {
                url: icon,
                size: new google.maps.Size(40, 40),
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(0, 20)
            },
            type: args.type
        });

        if (!markerGroups[args.type]) {
           markerGroups[args.type] = [];
        }
        markerGroups[args.type].push(marker);



        // Marker Icon hover
        google.maps.event.addListener(marker, 'mouseover', function() {
            marker.setIcon({
                url: icon_hover,
                size: new google.maps.Size(40, 40),
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(0, 20)
            });
        });

        google.maps.event.addListener(marker, 'mouseout', function() {
            marker.setIcon({
                url: icon,
                size: new google.maps.Size(40, 40),
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(0, 20)
            });
        });

        var currWindow = false; 
        bindInfoWindow(marker, args.map, args.html, currWindow);

    }

    function bindInfoWindow(marker, map, html) {
        const infoWindow = new google.maps.InfoWindow();
        google.maps.event.addListener(marker, 'click', function() {

            if(activeInfoWindow != null) activeInfoWindow.close();

            infoWindow.setContent(html);
            infoWindow.open(map, marker);
            activeInfoWindow = infoWindow;

        });

        google.maps.event.addListener(map, 'click', function() { 
            if(activeInfoWindow != null) { 
                activeInfoWindow.close();
            } 
        });
        
        document.querySelector('.js-markers-categories').addEventListener( 'click', function() {
            if(activeInfoWindow != null) {
                activeInfoWindow.close();
            }
        });
    }




    for(const markersCategory of markersCategories){


        markersCategory.addEventListener('click', () => {

            for(const markersNotActiveCategories of markersCategories){

                console.log('markersNotActiveCategories ', markersNotActiveCategories)
                if(!markersNotActiveCategories.classList.contains('active')) {
                    const notActiveCategory = markersNotActiveCategories.getAttribute('data-type');
                    console.log('notActiveCategory ', markerGroups[notActiveCategory])
                    for (let i = 0; i < markerGroups[notActiveCategory].length; i++) {
                        let marker = markerGroups[notActiveCategory][i];
                        marker.setVisible(false);
                    }
                }
            }

            const category = markersCategory.getAttribute('data-type');
            markersCategory.classList.toggle('active');
            for (let i = 0; i < markerGroups[category].length; i++) {
                let marker = markerGroups[category][i];
                if (!marker.getVisible()) {
                    marker.setVisible(true);
                } else {
                    marker.setVisible(false);
                }
            }

            for(const markersActiveCategories of markersCategories){
                const container = document.querySelector('.js-markers-categories');
                if(container.querySelectorAll('.active').length === 0) {
                    const activeCategory = markersActiveCategories.getAttribute('data-type');
                    for (let i = 0; i < markerGroups[activeCategory].length; i++) {
                        let marker = markerGroups[activeCategory][i];
                        marker.setVisible(true);
                    }
                }
            }
        });
    }
   
}